const useDiagnoses = () => {
  const hasAccess = true; // diagnoses are hardcoded for now; access gate TBD when backend lands
  const diagnoses = {
    data: [
      {
        id: "888888",
        name: "Galvos trauma"
      },
      {
        id: "999999",
        name: "Epilepsija"
      },

    ],
  };

  return { ...diagnoses, hasAccess };
};

export default useDiagnoses;